import React from "react";
import MobileLibraryView from "components/MobileView/MobileLibraryView";

const MobileView = () => {
  return (
    <div>
      <MobileLibraryView />
    </div>
  );
};

export default MobileView;
